import React from "react"

import ApplicationStatus from "@/components/application/ApplicationStatus"
import AppLayout from "@/components/layout/AppLayout"

const ApplicationStatusPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-8 md:py-12">
        <h1 className="mb-6 text-center text-2xl font-bold text-jungle md:mb-8 md:text-3xl">
          Application Status
        </h1>
        <ApplicationStatus />
      </div>
    </AppLayout>
  )
}

export default ApplicationStatusPage
